module.exports = __webpack_public_path__ + "img/440x420.a3f47fbf.png";